export enum WidgetActions {
  SetWidgetType = 'set widget type',
  LoadWidgetsSettings = 'load settings for widget',
  SaveWidgetsSettings = 'save widget settings',
  WidgetsSettingsAccepted = 'settings for widget loaded',
  WidgetsSettingsRiseError = 'rise url error for widgets',
  FetchGoogleHotel = 'fetch google hotel',
  SaveGoogleHotel = 'save google hotel',
  SaveGoogleHotelStatus = 'save google hotel status',
  GoogleHotelStatusAccepted = 'google hotel status accepted',
  GoogleHotelAccepted = 'google hotel accepted',
  ToggleGHotelModal = 'toggle google hotel modal',
}
